import { render, staticRenderFns } from "./EditorialIcon.vue?vue&type=template&id=a1b2ea0c&"
import script from "./EditorialIcon.vue?vue&type=script&lang=js&"
export * from "./EditorialIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports